export const AUTO_OPTION_VALUE = 'auto';
export const AUTO_LABEL_SUFFIX = ' (автоматически)';

export const worthOptions = [
	{ label: '5', value: 5 },
	{ label: '4', value: 4 },
	{ label: '3', value: 3 },
	{ label: '2', value: 2 },
	{ label: '1', value: 1 },
];

/** GraphQL WorthScore enum names */
export const rateOptions = [
	{ label: 'Отлично', value: 'EXCELLENT' },
	{ label: 'Хорошо', value: 'GOOD' },
	{ label: 'Нормально', value: 'NORMAL' },
	{ label: 'Плохо', value: 'BADLY' },
];

/** GraphQL WorthMatch enum names */
export const matchOptions = [
	{ label: 'Подходит', value: 'MATCH' },
	{ label: 'Не подходит', value: 'NO_MATCH' },
	{ label: 'Неизвестно', value: 'UNKNOWN' },
];

const SCORE_ALIASES = {
	EXCELLENT: 'EXCELLENT',
	excellent: 'EXCELLENT',
	GOOD: 'GOOD',
	good: 'GOOD',
	NORMAL: 'NORMAL',
	normal: 'NORMAL',
	BADLY: 'BADLY',
	badly: 'BADLY',
	5: 'EXCELLENT',
	4: 'GOOD',
	3: 'NORMAL',
	2: 'BADLY',
	1: 'BADLY',
};

const MATCH_ALIASES = {
	MATCH: 'MATCH',
	match: 'MATCH',
	NO_MATCH: 'NO_MATCH',
	noMatch: 'NO_MATCH',
	UNKNOWN: 'UNKNOWN',
	unknown: 'UNKNOWN',
};

export const normalizeWorthScore = (value) => {
	if (
		value === undefined ||
		value === null ||
		value === '' ||
		value === AUTO_OPTION_VALUE
	) {
		return null;
	}

	return SCORE_ALIASES[value] ?? SCORE_ALIASES[String(value)] ?? null;
};

/** Returns MATCH / NO_MATCH / UNKNOWN, or null if empty. */
export const normalizeWorthMatch = (value) => {
	if (
		value === undefined ||
		value === null ||
		value === '' ||
		value === AUTO_OPTION_VALUE
	) {
		return null;
	}

	return MATCH_ALIASES[value] ?? MATCH_ALIASES[String(value)] ?? null;
};

/** WorthInput: null means unknown. */
export const normalizeWorthMatchInput = (value) => {
	const normalized = normalizeWorthMatch(value);

	return normalized === null || normalized === 'UNKNOWN' ? null : normalized;
};

export const normalizeWorthValue = (value) => {
	if (
		value === undefined ||
		value === null ||
		value === '' ||
		value === AUTO_OPTION_VALUE
	) {
		return null;
	}

	const num = Number(value);

	return Number.isInteger(num) && num >= 1 && num <= 5 ? num : null;
};

export const withAutoLabel = (option) => {
	if (!option) return null;

	const baseLabel = option.label?.endsWith(AUTO_LABEL_SUFFIX)
		? option.label.slice(0, -AUTO_LABEL_SUFFIX.length)
		: option.label;

	return {
		...option,
		label: `${baseLabel}${AUTO_LABEL_SUFFIX}`,
		value: AUTO_OPTION_VALUE,
		score: option.score ?? option.value,
		isAuto: true,
	};
};

const prependAutoOption = (options, autoValue, normalize) => {
	const normalized = normalize(autoValue);

	if (normalized === null) {
		return options;
	}

	const base = options.find((option) => option.value === normalized);

	if (!base) {
		return options;
	}

	return [withAutoLabel(base), ...options];
};

export const buildWorthOptions = (autoValue) =>
	prependAutoOption(worthOptions, autoValue, normalizeWorthValue);

export const buildRateOptions = (autoValue) =>
	prependAutoOption(rateOptions, autoValue, normalizeWorthScore);

export const buildMatchOptions = () => matchOptions;
